import { render, staticRenderFns } from "./main.auditoria.vue?vue&type=template&id=a525ef92"
import script from "./main.auditoria.vue?vue&type=script&lang=js"
export * from "./main.auditoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports